import React from "react";
import { Grid, Paper, Typography, Button } from "@material-ui/core";
import classnames from "classnames";
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
// styles
import useStyles from "./styles";


export default function Error({view,type,title="Error",description='Oops! Something went wrong!', reload=false}) {
  var classes = useStyles();
//let history = useHistory();
  return (
    <Grid container className={classes.container} style={{width:view==="EmailListView"?"70vw":"100vw",height:view==="EmailListView"?"80vh":"100vh"}}>
      <Paper classes={{ root: classes.paperRoot }}>
        
        <ErrorOutlineIcon className={classnames(classes.textRow, classes.errorCode)} />
        <Typography variant="h1" color="primary">
          {title || ""}
        </Typography>
        <Typography
          variant="h6"
          color="text"
          colorBrightness="secondary"
          className={classnames(classes.textRow, classes.safetyText)}
        >
          {description || ""}
        </Typography>
        <Button
          variant="outlined"
          color="primary"
          // component={Link}
          // to="/app/Home"
          size="large"
          className={classes.backButton}
          onClick={()=>window.location.reload()}
        >
          Try Again!
        </Button>
        
      </Paper>
    </Grid>
  );
}
